export default __webpack_public_path__ + "static/media/queen.a0b50ab7.jpeg";